import { useEffect, useState } from "react";

export default () => {
    const [overThreshold, setOverThreshold] = useState(false);
    const threshold = 0;

    useEffect(() => {
        const scrollHandler = () => {
            if (window.pageYOffset > threshold) {
                setOverThreshold(true);
            } else {
                setOverThreshold(false);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler);
    }, []);

    return { overThreshold };
};
